import CHANNEL_VIDEO_LIST_VALUES from 'default-settings/channel-video-list-values';

export default {
  EXPAND_ON_CLICK: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
  NEVER_SHOW: CHANNEL_VIDEO_LIST_VALUES.NEVER_SHOW,
};



// WEBPACK FOOTER //
// ./src/default-settings/compact-show-video-list.js